module.exports = __webpack_public_path__ + "media/images/icons/icon_search_opened-64b6fb97c86a5441ac4251c26d15a91c.svg";